import React from "react";
import styled from "styled-components";
import { Text, Title, Column } from "../../../theme";

const Wrapper = styled.div`
  background: ${props => props.background};
  background-size: cover;
  height: 60vh;
  min-height: 632px;
  display: flex;
  align-items: center;
  justify-content: ${props => props.banner1 && "flex-end"};
  @media (max-width: 780px) {
    height: 100%;
    flex-direction: column;
    justify-content: center;
  }
`;

const StyledColumn = styled(Column)`
  width: 25%;
  justify-content: center;
  text-align: center;
  @media (max-width: 780px) {
    width: 95%;
    margin: 0;
  }
`;

const Icon = styled.img`
  width: 50px;
  height: 50px;
  margin: 1.25em 0;
`;

export default function Banner({ img, title, icon, text, id }) {
  return (
    <Wrapper background={`url('${img}')`} banner1={id === "banner1"}>
      <StyledColumn
        alignitems="center"
        width="25%"
        margin={id === "banner1" ? "0 4em 0 0" : "0 0 0 4em"}
      >
        <Icon src={icon} alt={`AchieveCE ${icon}`} />
        <Title white={id === "banner1"}>{title}</Title>
        <Text white={id !== "banner2"}>{text}</Text>
      </StyledColumn>
    </Wrapper>
  );
}



// WEBPACK FOOTER //
// ./src/components/screens/Corporate/components/Banner.jsx